<template>
  <div :style="`padding-left:${positionLevelOf(option) - 2}rem`">
    <template v-if="positionLevelOf(option) > 1">
      <template v-if="options[index + 1]?.positionLevel === option?.positionLevel">
        {{ positionLevelOf(option) > 1 ? '├' : '' }}
      </template>
      <template v-else>
        {{ positionLevelOf(option) > 1 ? '└' : '' }}
      </template>
    </template>
    {{ option?.name }}
  </div>
</template>
<script setup lang="ts">
// Stromové položky přicházejí z různých entit (Tag, PriceList…), společné je jen
// jméno a úroveň zanoření — proto strukturální typ místo konkrétní entity.
type TreeOption = {
  name?: string
  positionLevel?: number | null
}

defineProps<{ option: TreeOption; options: TreeOption[]; index: number }>()

const positionLevelOf = (option?: TreeOption) => option?.positionLevel ?? Number.NaN
</script>
